import request from '@/utils/request2'

// 列表(主数据列表)
export function loadScheduleJobListDataApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/listByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/save',
    method: 'post',
    data
  })
}

// 运行
export function runScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/run',
    method: 'post',
    data
  })
}

// 暂停
export function pauseScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/pause',
    method: 'post',
    data
  })
}

// 恢复
export function resumeScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/resume',
    method: 'post',
    data
  })
}

// 作废
export function deleteScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewScheduleJobApi(data) {
  return request({
    url: 'tms-schedule/scheduleJob/view',
    method: 'post',
    data
  })
}
